module.exports = __webpack_public_path__ + "static/media/mejora_continua.7e276332.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mejora_continua.png
// module id = 460
// module chunks = 1